import React, { Component } from 'react'
import { Table, Button, Modal, Input, Icon, Popover, Form, Radio, DatePicker, Upload, Popconfirm, Col, Row, Pagination } from 'antd'
import { app, api, config } from '../../../app'
import moment from 'moment'
import Editor from './UploadInformationModal/Editor'
import locale from 'antd/lib/date-picker/locale/zh_CN';


const RadioGroup = Radio.Group
const { RangePicker } = DatePicker;



function beforeUpload(file) {
    let format = ['image/jpeg', 'image/jpg', 'image/png'];
    const is = format.indexOf(file.type) > -1;
    if (!is) {
        app.alert('仅可上传文件类型为: ' + format.join("、"), 'warn');
        return Promise.reject();
    }
    return Promise.resolve();
}

class MyApplication extends Component {
    // 组件内部
    constructor(props) {
        super(props)

        this.state = {
            data: [],
            total: 0,
            page: 1,
            loginInfo: {
                name: '',
                mobile: '',
                idno: ''
            },
            componentNum: 1,
            modalInfo: [
            ],
            EditorFlag: false,
            detailF: 0,
            empowerFileModal: false, //注册信息弹窗
            prep_id: '', //当前选择查看授权文件弹窗的队伍申请的id
            templateImgModal: false, //授权模板文件图片弹窗
            showMoadlImg: '',  //模板弹窗展示的图片
            writeInfoModal: false,   //授权文件信息填写
            writeInfoType: '',   //当前填写的数据是民政局还是应急局的数据
            writeInfo: {    //授权文件信息填写
                d1: '',
                d2: '',
                d3: '',
                d4: '',
                d5: '',
                d6: '',
                d7: '',
                d8: '',
                d9: '',
                d10: '',
                d11: '',
                d12: '',
                d13: '',
                d14: '',
            },
            writeOK: false,
            writeOK2: false,
            downloadFlag: false,
            downloadFlag2: false,


            uploadInfoModal: false,  //上传注册信息弹窗
            uploadInfo: {    //上传注册信息
                name: '',
                authorize_name: '',
                authorize_img: '',
                authorize_start_time: '',
                authorize_end_time: '',
                if_long: '1',
                issuing_unit: '',
                credit_code: '',
            },
            up_img: '', //注册信息中的注册证明图片
            up_loading: false,   //是否正在上传图片
        }
        // this.starLogin()

    }

    componentDidMount() {
        this.starLogin()

    }

    starLogin = () => {
        //当前属于账号登录
        if (app.getData('indexno') != undefined) {
            app.post(api.TeamLogin, {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }).then(res => {
                // console.log(res)
                if (res.flag == 1) {
                    // if(app.getData('token') != ''){
                    app.setData('apply_token', res.data.apply_token);
                    app.setData('vname', res.data.apply_name);

                    app.setData('mobile', res.data.apply_mobile);

                    // }
                    this.setState({
                        componentNum: 2
                    })
                    app.post(api.TeamLists, {
                        apply_name: app.getData('vname'),
                        apply_mobile: app.getData('mobile'),
                        apply_token: app.getData('apply_token'),
                        page: 1
                    }).then(res2 => {
                        // console.log(res2)

                        // 将请求所需要的参数进行获取


                        if (res2.flag == 1) {

                            this.setState({
                                data: res2.data,
                                total: parseInt(res2.total || 0),
                            }, () => {
                                if (res2.data.length < 1) {
                                    return
                                }
                                app.post(api.TeamDetail, {
                                    apply_name: app.getData('vname'),
                                    apply_mobile: app.getData('mobile'),
                                    apply_token: app.getData('apply_token'),
                                    prep_id: res2.data[res2.data.length - 1].id
                                }).then(res3 => {

                                    let info = {}
                                    if (app.getData('InitialInfo') != undefined) {
                                        info = app.getData('InitialInfo')
                                    }
                                    // if (info.name == undefined) {
                                    info.name = app.getData('vname')
                                    // }
                                    // if (info.mobile == undefined) {
                                    info.mobile = app.getData('mobile')
                                    // }
                                    // if (info.teamname == undefined) {
                                    //     info.teamname = res3.data.teamname
                                    // }
                                    if (info.city_id == undefined || info.city_id.length < 1) {
                                        info.city_id = []
                                        info.city_id[0] = res3.data.area_id
                                        info.city_id[1] = res3.data.city_id
                                    }
                                    // if (info.idno == undefined) {
                                    info.idno = res3.data.idno
                                    // }
                                    // if (info.sms == undefined) {
                                    // info.sms = 1234
                                    // }
                                    // console.log(info)
                                    app.setData('InitialInfo', info)
                                })
                            })
                        } else {
                        }
                    })
                } else {
                    app.alert(res.msg, 'error', '45%')

                }
            })
        }

    }

    setComponentNum = () => {
        this.setState({
            componentNum: 1
        })
    }

    clickLogin = () => {

        const param = this.state.loginInfo;
        app.post(api.TeamLogin, param).then(res => {
            // console.log(res)
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')
                app.setData('apply_token', res.data.apply_token);
                this.setState({
                    componentNum: 2
                })
                app.post(api.TeamLists, {
                    apply_name: param.name,
                    apply_mobile: param.mobile,
                    apply_token: res.data.apply_token,
                    page: 1
                }).then(res2 => {
                    // console.log(res2)
                    if (res2.flag == 1) {
                        this.setState({
                            data: res2.data,
                            total: parseInt(res2.total || 0),

                        }, () => {
                            if (res2.data.length < 1) {
                                return
                            }
                            app.post(api.TeamDetail, {
                                apply_name: param.name,
                                apply_mobile: param.mobile,
                                apply_token: res.data.apply_token,
                                prep_id: res2.data[res2.data.length - 1].id
                            }).then(res3 => {

                                let info = {}
                                if (app.getData('InitialInfo') != undefined) {
                                    info = app.getData('InitialInfo')
                                }

                                // if (!info.name) {
                                info.name = param.name
                                // }
                                // if (!info.mobile) {
                                info.mobile = param.mobile
                                // }
                                // if (!info.teamname) {
                                //     info.teamname = res3.data.teamname
                                // }
                                if (info.city_id == undefined || info.city_id.length < 1) {
                                    info.city_id = []
                                    info.city_id[0] = res3.data.area_id
                                    info.city_id[1] = res3.data.city_id
                                }
                                // if (!info.idno) {
                                info.idno = res3.data.idno
                                // }
                                // if (!info.sms) {
                                // info.sms = 1234
                                // }

                                // console.log(info)
                                app.setData('InitialInfo', info)
                            })
                        })

                    }
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        })
    }

    getList = () => {
        const info = app.getData('InitialInfo')
        app.post(api.TeamLists, {
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            page: 1
        }).then(res => {
            // console.log(res)
            if (res.flag == 1) {
                this.setState({
                    data: res.data,
                    total: parseInt(res.total || 0),
                })
            } else {
                app.alert(res.msg, 'error', '45%')
            }
        })
    }

    _changeValue = (e) => {
        const { loginInfo } = this.state;
        loginInfo[e.target.name] = e.target.value.trim()
        this.setState({
            loginInfo
        })
    }


    // 查看详情
    Details = (e) => {

        const info = app.getData('InitialInfo')

        app.post(api.TeamDetail, {
            apply_name: e.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: e.id,
        }).then(res => {
            // console.log(res)
            if (res.flag == 1) {
                app.setData('applyinfo', res.data)
                this.setState({
                    EditorFlag: true,
                    detailF: 1,
                    modalInfo: e,
                    applyinfo: res.data
                }, () => {
                    app.setData('applyinfo', res.data)
                    // console.log(app.getData('applyinfo'))
                })
            } else {
                app.alert(res.msg, 'error', '45%')
            }


        })

    }
    // 编辑
    Editor = (e) => {

        const info = app.getData('InitialInfo')

        app.post(api.TeamDetail, {
            apply_name: e.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: e.id,
        }).then(res => {
            this.setState({
                modalInfo: e,
                detailF: 0,
                applyinfo: res.data
            }, () => {
                if (res.flag == 1) {
                    app.setData('applyinfo', res.data)
                    // console.log(app.getData('applyinfo'))
                    this.setState({
                        EditorFlag: true,
                    })
                } else {
                    app.alert(res.msg, 'error', '45%')
                }
            })
        })




    }



    // 删除
    Delete = (e) => {
        const info = app.getData('InitialInfo')

        app.post(api.TeamPrepDelete, {
            apply_name: e.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: e.id,
        }).then(res => {
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')
                app.post(api.TeamLists, {
                    apply_name: info.name,
                    apply_mobile: info.mobile,
                    apply_token: app.getData('apply_token'),
                    page: 1
                }).then(res => {
                    // console.log(res)
                    if (res.flag == 1) {
                        this.setState({
                            data: res.data,
                            total: parseInt(res.total || 0),

                        })
                    } else {
                        app.alert(res.msg, 'error', '45%')
                    }
                })
            } else {
                app.alert(res.msg, 'error', '45%')
            }
        })

    }

    // 关闭弹窗
    EditorModalCencel = () => {
        this.setState({
            EditorFlag: false
        }, () => {
            // const info = app.getData('InitialInfo')
            // app.post(api.TeamLists, {
            //     apply_name: info.name,
            //     apply_mobile: info.mobile,
            //     apply_token: app.getData('apply_token'),
            //     page: 1
            // }).then(res => {
            //     // console.log(res)
            //     if (res.flag == 1) {
            //         this.setState({
            //             data: res.data,
            //             total: parseInt(res.total || 0),
            //         })
            //     } else {
            //         app.alert(res.msg, 'error', '45%')
            //     }
            // })
            // this.starLogin()
        })
    }

    // 打开授权文件弹窗
    empowerFile = (e) => {
        this.setState({
            empowerFileModal: true,
            prep_id: e.id
        })
        const info = app.getData('InitialInfo')
        app.post(api.TeamPrepAuthFileDetail, {
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: e.id
        }).then(res => {
            // console.log(res)
            if (res.data[0].data.d1 != undefined) {  //如果用户已经提交过的话就降内容放到页面上，否则什么都不做
                this.setState({
                    writeOK: true,
                    downloadFlag: true
                })
            }
            if (res.data[1].data.d1 != undefined) {  //如果用户已经提交过的话就降内容放到页面上，否则什么都不做
                this.setState({
                    writeOK2: true,
                    downloadFlag2: true
                })
            }
        })
    }

    // 关闭授权文件弹窗
    empowerFileCencel = () => {
        this.setState({
            empowerFileModal: false
        }, () => {
            if (this.state.writeOK && this.state.writeOK2) {
                const info = app.getData('InitialInfo')
                app.post(api.TeamLists, {
                    apply_name: info.name,
                    apply_mobile: info.mobile,
                    apply_token: app.getData('apply_token'),
                    page: 1
                }).then(res => {
                    // console.log(res)
                    if (res.flag == 1) {
                        this.setState({
                            data: res.data,
                            total: parseInt(res.total || 0),
                        })
                    } else {
                        app.alert(res.msg, 'error', '45%')
                    }
                })
            }
        })
    }

    // 授权文件模板图片预览弹窗开启(民政局)
    templateImgModalopen = () => {
        const info = app.getData('InitialInfo')
        // console.log(info)
        app.post(api.TeamPrepAuthFileDetail, {
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: this.state.prep_id
        }).then(res => {
            // console.log(res)
            this.setState({
                templateImgModal: true,
                showMoadlImg: res.data[0].template_img

            })
        })

    }

    // 授权文件模板图片预览弹窗开启(应急局)
    templateImgModalopen2 = () => {
        const info = app.getData('InitialInfo')
        app.post(api.TeamPrepAuthFileDetail, {
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: this.state.prep_id
        }).then(res => {
            // console.log(res)
            this.setState({
                templateImgModal: true,
                showMoadlImg: res.data[1].template_img
            })
        })
    }



    // 授权文件模板图片预览弹窗关闭
    templateImgModalCencel = () => {
        this.setState({
            templateImgModal: false
        })
    }

    // 打开授权文件信息填写弹窗(民政局或应急局)，使用传的值进行判断
    writeInfoModalOpen = (type) => {
        if (type == 'minzheng') {
            const info = app.getData('InitialInfo')
            app.post(api.TeamPrepAuthFileDetail, {
                apply_name: info.name,
                apply_mobile: info.mobile,
                apply_token: app.getData('apply_token'),
                prep_id: this.state.prep_id
            }).then(res => {
                let writeInfo = {    //授权文件信息填写
                    d1: '',
                    d2: '',
                    d3: '',
                    d4: '',
                    d5: '',
                    d6: '',
                    d7: '',
                    d8: '',
                    d9: '',
                    d10: '',
                    d11: '',
                    d12: '',
                    d13: '',
                    d14: '',
                }
                if (res.data[0].data.d1 != undefined) {  //如果用户已经提交过的话就降内容放到页面上，否则什么都不做
                    this.setState({
                        writeInfo: res.data[0].data,
                        writeOK: true,
                        downloadFlag: true
                    })
                } else {
                    this.setState({
                        writeInfo: writeInfo,
                    })
                }

            })
        } else {
            const info = app.getData('InitialInfo')
            app.post(api.TeamPrepAuthFileDetail, {
                apply_name: info.name,
                apply_mobile: info.mobile,
                apply_token: app.getData('apply_token'),
                prep_id: this.state.prep_id
            }).then(res => {
                let writeInfo = {    //授权文件信息填写
                    d1: '',
                    d2: '',
                    d3: '',
                    d4: '',
                    d5: '',
                    d6: '',
                    d7: '',
                    d8: '',
                    d9: '',
                    d10: '',
                    d11: '',
                    d12: '',
                    d13: '',
                    d14: '',
                }
                // if (res.data[1].data.d1 != undefined) {  //如果用户已经提交过的话就降内容放到页面上，否则什么都不做

                if (res.data[1].data.d1 != undefined) {  //如果用户已经提交过的话就降内容放到页面上，否则什么都不做
                    this.setState({
                        writeInfo: res.data[1].data,
                        writeOK: true,
                        downloadFlag: true
                    })
                } else {
                    this.setState({
                        writeInfo: writeInfo,
                    })
                }
                // }
            })
        }
        this.setState({
            writeInfoModal: true,
            writeInfoType: type
        })
    }

    // 打开授权文件信息填写弹窗(应急局)
    // writeInfoModalOpen2 = () => {
    //     this.setState({
    //         writeInfoModal: true
    //     })
    // }


    // 关闭授权文件信息填写弹窗
    writeInfoModalCencel = () => {
        this.setState({
            writeInfoModal: false
        })
    }

    //获取授权文件填写的信息
    _getwriteInfo = (e) => {
        let { writeInfo } = this.state, value = e.target.value.trim()

        writeInfo[e.target.name] = value;
        this.setState({
            writeInfo
        })

    }


    // 提交授权文件填写的信息提交 (需辨识是民政局或者是应急局)
    upload = () => {
        let { writeInfoType, writeInfo } = this.state, typeTitle, key
        if (writeInfoType == 'minzheng') {    //当前填写的是民政局
            typeTitle = '民政局'
            key = 'auth_mz'
        } else { // 当前填写的是应急局
            typeTitle = '应急局'
            key = 'auth_yj'
        }
        if (!writeInfo.d1) {
            app.alert('文件名称未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d2) {
            app.alert('团队名称未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d3) {
            app.alert('救援团队类型未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d4) {
            app.alert(typeTitle + '名称未填写', 'error', '45%')
            return
        }

        if (!writeInfo.d5) {
            app.alert('申请单位名称未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d6) {
            app.alert('申请地区未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d7) {
            app.alert('区域未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d8) {
            app.alert('活动地区未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d9) {
            app.alert('申请人名称未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d10) {
            app.alert('身份证号未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d11) {
            app.alert('申请地区未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d12) {
            app.alert('申请团队名称未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d13) {
            app.alert('业务经办人姓名未填写', 'error', '45%')
            return
        }
        if (!writeInfo.d14) {
            app.alert('业务经办人联系电话未填写', 'error', '45%')
            return
        }

        this.setTeamPrepAuthFileEdit(writeInfo, key)

    }



    setTeamPrepAuthFileEdit = async (writeInfo, key) => {    //设置填写信息(包含了设置)
        const info = app.getData('InitialInfo')

        app.post(api.TeamPrepAuthFileEdit, { //将填写的内容提交给后台
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: this.state.prep_id,
            file_data: JSON.stringify(writeInfo),
            key: key
        }).then(res => {
            if (res.flag == 1) {
                // 请求成功
                app.alert(res.msg, 'success', '45%')
                // 当提交成功后需要将对应的下载按钮变为可用,对应填写按钮变成编辑按钮
                if (this.state.writeInfoType == 'minzheng') {    //当前填写的是民政局
                    this.setState({
                        writeOK: true,
                        downloadFlag: true,
                        writeInfoModal: false

                    })
                } else { // 当前填写的是应急局
                    this.setState({
                        writeOK2: true,
                        downloadFlag2: true,
                        writeInfoModal: false

                    })
                }
                return res
            } else {
                // 请求失败
                app.alert(res.msg, 'error', '45%')
            }
        })
    }

    openUploadInfo = (e) => {    //开启注册信息弹窗

        const info = app.getData('InitialInfo')
        app.post(api.TeamPrepAuthDetail, {
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: e.id
        }).then(res => {
            // console.log(res)
            this.setState({
                uploadInfo: res.data,
                up_img: res.data.authorize_img
            })
        })
        this.setState({
            uploadInfoModal: true,
            prep_id: e.id
        })
    }

    shutUploadInfo = () => {     //关闭注册信息弹窗
        this.setState({
            uploadInfoModal: false
        })
    }

    setUploadInfo = () => {  //确认编辑注册信息
        let { uploadInfo } = this.state

        if (!uploadInfo.name) {
            app.alert('法人代表未填写', 'error', '45%')
            return
        }
        if (!uploadInfo.authorize_name) {
            app.alert('注册名称未填写', 'error', '45%')
            return
        }
        if (!uploadInfo.credit_code) {
            app.alert('信用编码未填写', 'error', '45%')
            return
        }
        if (!uploadInfo.issuing_unit) {
            app.alert('发证机关未填写', 'error', '45%')
            return
        }

        if (uploadInfo.if_long == 2 && uploadInfo.authorize_start_time == '' && uploadInfo.authorize_end_time == '') {
            app.alert('营业期限未填写', 'error', '45%')
            return
        }

        if (!this.state.up_img) {
            app.alert('注册证明未上传', 'error', '45%')
            return
        }

        const info = app.getData('InitialInfo')
        let upload = this.state.uploadInfo
        app.post(api.TeamPrepAuthEdit, {
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: this.state.prep_id,
            name: upload.name,
            authorize_name: upload.authorize_name,
            authorize_img: this.state.up_img,
            authorize_start_time: upload.authorize_start_time,
            authorize_end_time: upload.authorize_end_time,
            if_long: upload.if_long,
            issuing_unit: upload.issuing_unit,
            credit_code: upload.credit_code,

        }).then(res => {
            if (res.flag == 1) {
                // 请求成功
                app.alert(res.msg, 'success', '45%')
                this.setState({
                    uploadInfoModal: false
                })
            } else {
                // 请求失败
                app.alert(res.msg, 'error', '45%')
            }
        })

    }

    getUploadInfo = (e) => { //获取input填写的注册信息
        let { uploadInfo } = this.state, value = e.target.value.trim()

        uploadInfo[e.target.name] = value;
        this.setState({
            uploadInfo
        })
    }

    isLoing = (e) => {   //是否长期按钮
        let { uploadInfo } = this.state
        uploadInfo.if_long = e.target.value
        this.setState({
            uploadInfo
        })
    }

    getTime = (e) => {    //获取时间
        // console.log(e)
        let { uploadInfo } = this.state
        uploadInfo.authorize_start_time = e[0].format("YYYY-MM-DD")
        uploadInfo.authorize_end_time = e[1].format("YYYY-MM-DD")
        this.setState({
            uploadInfo
        })
    }


    handleImgUploadChage = ({ file }) => {   //上传注册信息图片完成后
        if (file.status === 'uploading') {
            this.setState({ up_loading: true });
            return;
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            this.setState({ up_img: file.response.data.url, up_loading: false });
        }
    }


    // 下载
    clickDownload = () => {
        //将对应的数据传到后台，然后就下载
        const info = app.getData('InitialInfo')
        app.post(api.TeamPrepAuthFileDetail, {
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: this.state.prep_id
        }).then(res => {
            if (res.flag == 1) {
                // 请求成功
                this.downLoad('auth_mz', res.data[0].data, "存心救援授权文件（民政局)", this.state.prep_id)
            } else {
                // 请求失败
                app.alert(res.msg, 'error', '45%')
            }
        })

    }

    clickDownload2 = () => {
        //将对应的数据传到后台，然后就下载
        const info = app.getData('InitialInfo')
        app.post(api.TeamPrepAuthFileDetail, {
            apply_name: info.name,
            apply_mobile: info.mobile,
            apply_token: app.getData('apply_token'),
            prep_id: this.state.prep_id
        }).then(res => {
            if (res.flag == 1) {
                // 请求成功
                this.downLoad('auth_yj', res.data[1].data, "存心救援授权文件（应急局)", this.state.prep_id)
            } else {
                // 请求失败
                app.alert(res.msg, 'error', '45%')
            }
        })

    }


    downLoad = (key, data, fileName, id) => {
        const info = app.getData('InitialInfo')

        let that = this;
        let xhr = new XMLHttpRequest()
        xhr.open('POST', config.serverUrl + '/TeamPrep/getFilePdf', true)
        xhr.responseType = 'blob'
        let fd = new FormData();
        fd.append("apply_name", info.name);
        fd.append("apply_mobile", info.mobile);
        fd.append("apply_token", app.getData('apply_token'));
        fd.append("prep_id", id);
        fd.append("key", key);
        fd.append("file_data", JSON.stringify(data));
        xhr.send(fd);
        xhr.onload = function () {
            if (this.status == 200) {
                let blob = this.response
                // console.log(blob)
                that.downloadFile1(blob, 'pdf', fileName + '.pdf');
            }
        }
    }

    downloadFile1(data, type, fileName) {
        let blob = new Blob([data], { type: `application/${type};charset=utf-8` });
        // console.log(123)
        // 获取heads中的filename文件名
        let downloadElement = document.createElement('a');
        // 创建下载的链接
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        // 下载后文件名
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        // 点击下载
        downloadElement.click();
        // 下载完成移除元素
        document.body.removeChild(downloadElement);
        // 释放掉blob对象
        window.URL.revokeObjectURL(href);
    }


    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataSource = async (page = 1) => {
        await this.setState({ page })
        let { dataType, search_type, search_val } = this.state, params = {
            page,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            apply_token: app.getData('apply_token')
        }
        let { flag, data, msg, total } = await app.post(api.TeamLists, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setState({
                data: data,
                total: parseInt(total || 0),
            })
        }
    }


    // 页面渲染区
    render() {
        // console.log(this.state)
        let { data, writeInfo, writeOK, writeOK2, downloadFlag, downloadFlag2, uploadInfo, up_img, up_loading, total, page } = this.state
        // const [dateFormat] = useState('YYYY/MM/DD');
        const columns = [

            {
                title: '申请编号',
                width: 150,
                dataIndex: 'apply_no',
                // key: '1',
            },
            {
                title: '申请名称',
                width: 150,
                dataIndex: 'teamname',
                // key: '2',
            },
            {
                title: '申请人',
                dataIndex: 'name',
                // key: '3',
                width: 150,

            },
            {
                title: '申请类别',
                dataIndex: 'type',
                // key: '4',
                width: 150,

            },

            {
                title: '申请时间',
                dataIndex: 'created_at',
                // key: '5',
                width: 200,

            },
            {
                title: '督导官审核',
                // dataIndex: 'audit_title',
                // key: '6',
                width: 200,
                render: (record) => <div>
                    {/* {
                        console.log(record)
                    } */}
                    <p>{record.one_vname}</p>
                    <p>{record.one_audit_title}

                        <Popover content={record.detail} >
                            <span style={{ color: '#1890ff' }}>{record.one_audit_title == '审核不通过' ? '查看原因' : ''}</span>
                        </Popover>
                    </p>
                    <p>{record.one_time}</p>
                </div>

            },
            {
                title: '二级审核',
                // dataIndex: 'audit_title',
                // key: '7',
                width: 200,
                render: (record) => <div>
                    <p>{record.two_vname}</p>
                    <p>{record.two_audit_title}
                    </p>
                    <p>{record.two_time}</p>
                </div>

            },
            {
                title: '注册信息审核',
                // dataIndex: 'audit_title',
                // key: '7',
                width: 200,
                render: (record) => <div>
                    {/* {
                        console.log(record)
                    } */}
                    <p>{record.auth_vname}</p>
                    <p>{record.auth_audit_title}
                    </p>
                    <p>{record.auth_time}</p>
                </div>

            },
            {
                title: '操作',
                key: 'operation',
                width: 200,
                height: 200,
                render: (record) => <div>
                    <div >
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30 }} onClick={() => this.Details(record)}>详情</Button>
                    </div>
                    <div style={{ marginTop: 7 }} hidden={record.one_audit == 1 && record.two_audit == 1}>
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30 }} onClick={() => this.Editor(record)}>编辑</Button>
                    </div>
                    <div style={{ marginTop: 7 }} hidden={record.one_audit == 1 || record.two_audit == 1}>
                        <Popconfirm placement="bottom"
                            title="确定删除？"
                            cancelText="取消"
                            okText="确定"
                            onConfirm={() => this.Delete(record)}
                        >
                            <Button style={{ color: 'red', width: 80, height: 30, borderColor: 'red' }} >删除</Button>
                        </Popconfirm>

                    </div>

                    <div style={{ marginTop: 7 }} hidden={!(record.one_audit == 1 && record.two_audit == 1)}>
                        {/* 当督导官审核和二级审核都通过后才可以展示 下载授权文件 按钮 */}
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', height: 30 }} onClick={() => this.empowerFile(record)}>下载授权文件</Button>
                    </div>

                    <div style={{ marginTop: 7 }} hidden={!(record.one_audit == 1 && record.two_audit == 1 && record.auth_file_set)}>
                        {/* 当督导官审核和二级审核都通过后才可以展示 上传注册信息 按钮 */}
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', height: 30 }} onClick={() => this.openUploadInfo(record)}>上传注册信息</Button>
                    </div>

                </div>,
            },
        ];

        const myApplication = (
            <div style={{ marginTop: 20 }}>
                {/* 组件标题 */}
                <p style={{ fontSize: 16 }} >我的申请</p>
                {/* 组件标题end */}


                <div>
                    <Table columns={columns} dataSource={data} scroll={{ y: 700 }}
                        rowKey={record => record.id}
                        pagination={false}
                        footer={() => {
                            return (
                                <Row hidden={data.length === 0}>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Pagination total={total} size="small" pageSize={20} current={page}
                                            showTotal={(total) => `总数量：${total}`}
                                            onChange={this.dataSource} />
                                    </Col>
                                </Row>
                            )
                        }} />
                </div>

            </div>
        )

        const myApplicationLogin = (
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div >
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: 200, textAlign: 'right', fontSize: 16 }}>
                            <div style={{ height: 40, paddingTop: 5, justifyItems: 'center', justifyContent: 'flex-end', marginBottom: 5 }}><span style={{ color: 'red' }}>*</span>申请人姓名：</div>
                            <div style={{ height: 40, paddingTop: 5, justifyItems: 'center', justifyContent: 'flex-end', marginBottom: 5 }}><span style={{ color: 'red' }}>*</span>申请人手机号码：</div>
                            <div style={{ height: 40, paddingTop: 5, justifyItems: 'center', justifyContent: 'flex-end', marginBottom: 5 }}><span style={{ color: 'red' }}>*</span>申请人身份证号码：</div>




                        </div>
                        {/* 表单内容 */}
                        <div style={{ fontSize: 16 }}>
                            <div style={{ height: 40, marginBottom: 5 }}>
                                <Input style={{ width: 400 }} onChange={this._changeValue} name="name" placeholder="请输入申请人姓名" maxLength={8}></Input>
                            </div>
                            <div style={{ height: 40, marginBottom: 5 }}>
                                <Input style={{ width: 400 }} onChange={this._changeValue} name="mobile" placeholder="请输入申请人手机号码" maxLength={11}></Input>
                            </div>
                            <div style={{ height: 40, marginBottom: 5 }}>
                                <Input style={{ width: 400 }} onChange={this._changeValue} name="idno" placeholder="请输入申请人身份证号码" maxLength={18}></Input>
                            </div>


                        </div>
                        {/* 表单内容end */}



                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 50 }}>
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 300 }} onClick={this.clickLogin}>提交</Button>
                    </div>

                    <p style={{ marginTop: 20, color: 'red', textAlign: 'center' }}>注：请输入申请人信息查看申请记录，如已注册存心救援账号，可登录后查看申请记录</p>
                </div>
            </div>

        )

        return (
            <div>
                {this.state.componentNum == 1 ? myApplicationLogin : myApplication}

                {/* 备注信息 */}
                <div style={{ color: 'red' }} hidden={this.state.componentNum == 1}>
                    <p >注：队伍申请审核通过后，申请信息仍未对外公开（系统暂时查询不到），申请人需要做以下操作：</p>
                    <p >1、下载【授权文件】到民政局和应急局注册登记队伍信息</p>
                    <p >2、上传已注册登记信息，管理员审核通过后，队伍信息申请成功</p>
                </div>

                {/* 授权文件弹窗 */}
                <Modal visible={this.state.empowerFileModal} width={700} footer={null} onCancel={this.empowerFileCencel} centered={true}>
                    {/* 存心救援授权文件（民政局） */}
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        {/* 文字title */}
                        <span style={{ color: '#00a9ff', lineHeight: '32px' }}>存心救援授权文件（民政局）</span>
                        {/* 按钮 */}
                        <div>
                            <Button style={{ backgroundColor: '#1890FF', color: '#fff', height: 30, marginRight: 5 }} onClick={this.templateImgModalopen}>预览模板</Button>
                            <Button style={{ backgroundColor: '#1890FF', color: '#fff', height: 30, marginRight: 5 }} onClick={() => this.writeInfoModalOpen('minzheng')}>{!writeOK ? '填写' : '编辑'}</Button>
                            {/* 填写提交成功后才会显示带有编辑功能的 编辑 按钮 */}

                            {/* <Button style={{ backgroundColor: '#c1c1c1', color: '#fff', height: 30 }}>下载</Button> */}
                            {/* 填写提交成功后才会显示带有下载功能的 下载 按钮 */}
                            <Button style={!downloadFlag ? { backgroundColor: '#c1c1c1', color: '#fff' } : { backgroundColor: '#1890FF', color: '#fff' }} disabled={!downloadFlag} onClick={this.clickDownload}>下载</Button>
                        </div>
                    </div>


                    {/* 存心救援授权文件（应急局） */}
                    <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 10 }}>
                        {/* 文字title */}
                        <span style={{ color: '#00a9ff', lineHeight: '32px' }}>存心救援授权文件（应急局）</span>
                        {/* 按钮 */}
                        <div>
                            <Button style={{ backgroundColor: '#1890FF', color: '#fff', height: 30, marginRight: 5 }} onClick={this.templateImgModalopen2}>预览模板</Button>
                            <Button style={{ backgroundColor: '#1890FF', color: '#fff', height: 30, marginRight: 5 }} onClick={() => this.writeInfoModalOpen('yingji')}>{!writeOK2 ? '填写' : '编辑'}</Button>
                            {/* 填写提交成功后才会显示带有编辑功能的 编辑 按钮 */}

                            {/* <Button style={{ backgroundColor: '#c1c1c1', color: '#fff', height: 30 }}>下载</Button> */}
                            {/* 填写提交成功后才会显示带有下载功能的 下载 按钮 */}
                            <Button style={!downloadFlag2 ? { backgroundColor: '#c1c1c1', color: '#fff' } : { backgroundColor: '#1890FF', color: '#fff' }} disabled={!downloadFlag2} onClick={this.clickDownload2}>下载</Button>
                        </div>
                    </div>

                    <p style={{ color: '#fb6519', textAlign: 'center' }}>注：下载【授权文件】到民政局和应急局注册登记队伍信息，如已注册登记请忽略</p>
                </Modal>

                {/* 授权文件模板图片预览 */}
                <Modal visible={this.state.templateImgModal} width={1200} footer={null} onCancel={this.templateImgModalCencel} centered={true}>
                    {
                        <img src={config.imgUrl + this.state.showMoadlImg} alt="" style={{ width: 1000, marginLeft: 100 }} />
                    }

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                        <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff' }} onClick={this.templateImgModalCencel}>关闭</Button>
                    </div>
                </Modal>


                {/* 授权文件信息填写 */}
                <Modal visible={this.state.writeInfoModal} width={1200} footer={null} onCancel={this.writeInfoModalCencel} centered={true}>
                    <div style={{ width: 1200, height: 1200, display: 'flex' }}>

                        <div style={{ width: 1200, paddingLeft: 40, paddingRight: 40, paddingTop: 70, paddingBottom: 120, fontSize: 22 }} id="JPGDOM">
                            {/* 标题 */}
                            <p style={{ textAlign: 'center', fontSize: 34, border: 0, borderBottom: 3, borderColor: 'red', borderStyle: 'double', width: '60%', margin: 'auto', color: 'red' }}>
                                <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d1" value={writeInfo.d1}
                                    style={{ outline: 'none', border: 0, textAlign: 'center', width: 468 }} /><span>存心救援文件</span>
                            </p>

                            <p style={{ textAlign: 'center', fontSize: 34, margin: 'auto', paddingTop: 80, paddingBottom: 80 }}>
                                关于同意成立
                                            <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d2" value={writeInfo.d2}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid', textAlign: 'center', width: 300 }} />
                                            存心救援
                                            <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d3" value={writeInfo.d3}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid', textAlign: 'center', width: 300 }} />
                                            的函
                                </p>

                            {/* 内容 */}
                            <p>
                                致
                                    <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d4" value={writeInfo.d4}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid', textAlign: 'center' }} />
                                {this.state.writeInfoType == 'minzheng' ? '民政局' : '应急局'}：
                                </p>
                            <p style={{ textIndent: '2em' }}>
                                <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d5" value={writeInfo.d5}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    为
                                    <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d6" value={writeInfo.d6}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    地区“存心救援品牌公司”，负责存心救援品牌在
                                    <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d7" value={writeInfo.d7}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    区域内存心救援品牌标识及衍生品在
                                    <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d8" value={writeInfo.d8}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    地区的使用、推广及管理工作。经研究决定：同意
                                    <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d9" value={writeInfo.d9}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    （身份证号：<input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d10" value={writeInfo.d10}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />）
                                    为举办者在
                                    <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d11" value={writeInfo.d11}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    申请成立
                                    <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d12" value={writeInfo.d12}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    ，业务经办人：
                                    <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d13" value={writeInfo.d13}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    ，联系电话：
                                    <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d14" value={writeInfo.d14}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    ，请贵单位依法予以受理。
                                </p>
                            {/* 页尾 */}
                            <p style={{ textIndent: '2em' }}>此致</p>
                            <p>敬礼！</p>
                            <p style={{ textIndent: '25em' }}>
                                <input type="text"
                                    onChange={this._getwriteInfo}
                                    name="d5" value={writeInfo.d5}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                            </p>
                            <p style={{ textIndent: '25em' }}>申请日期：<span style={{ fontSize: 16 }}>________年________月________日</span></p>
                        </div>

                    </div>


                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.upload}>提交</Button>
                        <Button style={{ width: 200 }} onClick={this.writeInfoModalCencel}>关闭</Button>
                    </div>
                </Modal>

                {/* 注册信息上传 */}
                <Modal title="上传法人注册信息" visible={this.state.uploadInfoModal} width={1200} footer={null} onCancel={this.shutUploadInfo} centered={true}>
                    <div style={{ paddingLeft: 350 }}>
                        <div style={{ paddingBottom: 30 }}>
                            <span style={{ color: 'red' }}>*</span>法人代表：<Input style={{ width: 400 }} placeholder="请称输入法人代表" onChange={this.getUploadInfo} name="name" value={uploadInfo.name} />
                        </div>
                        <div style={{ paddingBottom: 30 }}>
                            <span style={{ color: 'red' }}>*</span>注册名称：<Input style={{ width: 400 }} placeholder="请称输入注册名称" onChange={this.getUploadInfo} name="authorize_name" value={uploadInfo.authorize_name} />
                        </div>
                        <div style={{ paddingBottom: 30 }}>
                            <span style={{ color: 'red' }}>*</span>信用编码：<Input style={{ width: 400 }} placeholder="请称输入信用编码" onChange={this.getUploadInfo} name="credit_code" value={uploadInfo.credit_code} />
                        </div>
                        <div style={{ paddingBottom: 30 }}>
                            <span style={{ color: 'red' }}>*</span>发证机关：<Input style={{ width: 400 }} placeholder="请称输入发证机关" onChange={this.getUploadInfo} name="issuing_unit" value={uploadInfo.issuing_unit} />
                        </div>
                        <div style={{ paddingBottom: 30 }}>
                            <span style={{ color: 'red' }}>*</span>是否长期：<RadioGroup options={[
                                { label: '是', value: '1' },
                                { label: '否', value: '2' },
                            ]} value={uploadInfo.if_long} onChange={this.isLoing} />
                        </div>

                        <div style={{ paddingBottom: 30 }} hidden={uploadInfo.if_long == 1}>
                            <span style={{ color: 'red' }}>*</span>营业期限：<RangePicker locale={locale} onChange={this.getTime} value={uploadInfo.authorize_start_time == '' ? '' : [moment(uploadInfo.authorize_start_time), moment(uploadInfo.authorize_end_time)]} />
                        </div>

                        <div style={{ paddingBottom: 30, display: 'flex' }}>
                            <div style={{ color: 'red' }}>*</div>注册证明：<Upload
                                accept='image/jpeg, image/jpg, image/png'
                                action={config.serverUrl + "/TeamApply/imageUpload"}
                                name="image"
                                onChange={this.handleImgUploadChage}
                                beforeUpload={beforeUpload}
                                listType="picture-card"
                                showUploadList={false}
                            >
                                {up_img ?
                                    <img src={config.imgUrl + up_img} style={{ width: 86, height: 86 }} alt="证书" /> :
                                    (
                                        <div>
                                            <Icon type={up_loading ? 'loading' : 'plus'} />
                                            <div className="ant-upload-text">上传</div>
                                        </div>
                                    )}
                            </Upload>

                        </div>

                    </div>
                    <p style={{ color: '#fb6920', textAlign: 'center' }}>注：上传注册信息需要省级管理员审核通过后方可对外展示队伍信息注册信息编辑后需要重新审核</p>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
                        <Button style={{ width: 200, color: '#1890FF', marginRight: 30 }} onClick={this.shutUploadInfo}>关闭</Button>
                        <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff' }} onClick={this.setUploadInfo}>提交</Button>
                    </div>
                </Modal>



                {/* 申请弹窗 */}
                <Modal title={this.state.modalInfo.length < 1 ? '' : this.state.modalInfo.teamname} visible={this.state.EditorFlag} width={'95%'} footer={null} onCancel={this.EditorModalCencel}>
                    <Editor modalInfo={this.state.modalInfo}
                        apply={1}   //申请  
                        applyinfo={this.state.applyinfo}
                        detailF={this.state.detailF}
                        setComponentNum={this.setComponentNum}  //当用户修改了个人信息，那么让用户返回登录页面
                        EditorModalCencel={this.EditorModalCencel}
                        starLogin={this.starLogin}
                        getList={this.getList}
                    />
                </Modal>
            </div>

        )
    }
}



export default MyApplication



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/MyApplication.jsx